// Mock data for Kevin Panchal's portfolio
export const personalInfo = {
  name: "Kevin Panchal",
  title: "Cross Platform & Web Developer + Data Analyst",
  tagline: "Transforming complex data into intelligent solutions across web, mobile, and analytics platforms",
  description: "Multi-disciplinary developer with expertise spanning data analysis, full-stack web development, and cross-platform mobile applications. I specialize in building scalable solutions that bridge the gap between raw data insights and user-friendly applications. With proficiency in modern frameworks and a passion for performance optimization through Rust, I deliver comprehensive digital solutions that drive business value.",
  email: "kevinpanchal2004@gmail.com",
  location: "Available for Remote & On-site Projects",
  social: {
    github: "https://github.com/KevinPanchal2444",
    linkedin: "https://www.linkedin.com/in/kevinpanchal24",
    instagram: "https://www.instagram.com/kevin.panchal.24?igsh=eTEzd3NmNnltY3V0"
  }
};

export const skills = [
  {
    category: "Data Analysis & Visualization",
    technologies: ["Python", "SQL", "Power BI", "Pandas", "NumPy", "Matplotlib"],
    level: 90
  },
  {
    category: "Web Development",
    technologies: ["React", "Next.js", "Tailwind CSS", "JavaScript", "TypeScript"],
    level: 95
  },
  {
    category: "Cross-Platform Development",
    technologies: ["Flutter", "Dart", "Mobile UI/UX"],
    level: 85
  },
  {
    category: "Backend & Databases",
    technologies: ["Rust", "Node.js", "MongoDB", "Firebase", "PostgreSQL"],
    level: 88
  },
  {
    category: "Tools & Platforms",
    technologies: ["Git", "Docker", "Google Cloud", "Figma"],
    level: 82
  }
];

export const projects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "A full-featured e-commerce platform with real-time inventory management, payment processing, and admin dashboard.",
    technologies: ["React", "Node.js", "PostgreSQL", "Redis"],
    category: "Web App",
    status: "Live",
    year: "2024",
    metrics: {
      performance: "Real-time updates",
      impact: "Secure payments"
    },
    link: "VIEW PROJECT"
  },
  {
    id: 2,
    title: "Task Management App",
    description: "Collaborative task management tool with real-time updates, team workspaces, and advanced filtering options.",
    technologies: ["Next.js", "TypeScript", "Supabase", "TailwindCSS"],
    category: "Web App",
    status: "Live",
    year: "2025",
    metrics: {
      performance: "Instant sync",
      impact: "Team collaboration"
    },
    link: "VIEW PROJECT"
  },
  {
    id: 3,
    title: "Weather Dashboard",
    description: "Real-time weather tracking application with interactive maps, detailed forecasts, and severe weather alerts.",
    technologies: ["React", "OpenWeather API", "Mapbox", "Chart.js"],
    category: "Web App",
    status: "Live",
    year: "2024",
    metrics: {
      performance: "Live data",
      impact: "Global coverage"
    },
    link: "VIEW PROJECT"
  },
  {
    id: 4,
    title: "Real-Time Chat Application",
    description: "Scalable chat platform with WebSocket support, file sharing, message encryption, and user presence indicators.",
    technologies: ["React", "Socket.io", "Node.js", "MongoDB"],
    category: "Web App",
    status: "Featured",
    year: "2025",
    metrics: {
      performance: "Instant messaging",
      impact: "End-to-end encryption"
    },
    link: "VIEW PROJECT"
  },
  {
    id: 5,
    title: "ML Studio",
    description: "Machine learning experimentation platform with model training, evaluation metrics, and deployment pipeline.",
    technologies: ["Python", "TensorFlow", "FastAPI", "React", "Docker"],
    category: "Open Source",
    status: "In Progress",
    year: "2025",
    metrics: {
      performance: "GPU accelerated",
      impact: "AutoML pipeline"
    },
    link: "VIEW PROJECT"
  },
  {
    id: 6,
    title: "Discord Bot",
    description: "Feature-rich Discord bot with moderation tools, music playback, custom commands, and server analytics.",
    technologies: ["Python", "Discord.py", "PostgreSQL", "Redis"],
    category: "Open Source",
    status: "Live",
    year: "2023",
    metrics: {
      performance: "1000+ servers",
      impact: "Active community"
    },
    link: "VIEW PROJECT"
  },
  {
    id: 7,
    title: "Workzen",
    description: "All-in-one productivity suite combining project management, time tracking, and team communication features.",
    technologies: ["Flutter", "Dart", "Firebase", "Node.js"],
    category: "Mobile",
    status: "Featured",
    year: "2025",
    metrics: {
      performance: "Cross-platform",
      impact: "Productivity boost"
    },
    link: "VIEW PROJECT"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Product Manager at TechCorp",
    content: "Kevin's ability to transform complex data into actionable insights is remarkable. The analytics dashboard he built has become central to our decision-making process.",
    avatar: "https://ui-avatars.com/api/?name=Sarah+Johnson&background=4ECDC4&color=fff"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "CTO at StartupXYZ",
    content: "Working with Kevin was a game-changer for our mobile app. His Flutter expertise and attention to performance delivered a seamless cross-platform experience.",
    avatar: "https://ui-avatars.com/api/?name=Michael+Chen&background=FF6B6B&color=fff"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Data Science Lead",
    content: "Kevin bridges the gap between data science and engineering brilliantly. His full-stack skills combined with data analysis expertise make him an invaluable collaborator.",
    avatar: "https://ui-avatars.com/api/?name=Emily+Rodriguez&background=45B7D1&color=fff"
  }
];